if (!window.tokuBuyNowLoaded) {
  window.tokuBuyNowLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-toku-buy-now]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const form = document.getElementById(button.dataset.formId);
    const errorElement = button.parentElement.querySelector('[data-toku-buy-now-error]');
    const defaultError = button.dataset.errorMessage || '';

    if (!form) {
      if (errorElement) errorElement.textContent = defaultError;
      return;
    }

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) {
      if (errorElement) errorElement.textContent = defaultError;
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (errorElement) errorElement.textContent = '';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(data?.description || data?.message || defaultError);
      }

      window.location.assign('/checkout');
    } catch (error) {
      if (errorElement) errorElement.textContent = error.message || defaultError;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
}